import { ref, Ref } from 'vue';

export enum TestOptionType {
  'CONTROL' = 'control',
  'TARGET' = 'target',
  'TARGET_A' = 'target A',
  'TARGET_B' = 'target B',
}

export enum AnalyticsCookies {
  CMPConsents = 'cmp_consents',
  AdobeTarget = 'Adobe_Target',
  ABTesting = 'A/B-Testing',
}

const targetMapping = new Map<string, TestOptionType | undefined>();
let useLocalStorage = false;

function getStorageKey(key: string) {
  const emhABTestPrefix = 'EMH::ab-testing::EMH';

  return key.startsWith(emhABTestPrefix) ? key : `${emhABTestPrefix}-${key}`;
}

export function useABTesting(key) {
  const storageKey = getStorageKey(key);

  if (!targetMapping.has(storageKey)) {
    targetMapping.set(storageKey, localStorage.getItem(storageKey) as TestOptionType);
  }

  const target: Ref<TestOptionType | undefined> = ref(targetMapping.get(storageKey));

  function setTarget(optionType: TestOptionType) {
    targetMapping.set(storageKey, optionType);
    target.value = optionType;

    if (useLocalStorage) {
      localStorage.setItem(storageKey, optionType);
    }
  }

  function reset() {
    setTarget(TestOptionType.CONTROL);

    if (useLocalStorage) {
      localStorage.setItem(storageKey, TestOptionType.CONTROL);
    }
  }

  function enableLocaleStorageUsage() {
    useLocalStorage = true;

    if (!localStorage.getItem(storageKey) && targetMapping.get(storageKey)) {
      localStorage.setItem(storageKey, targetMapping.get(storageKey) as TestOptionType);
    }
  }

  function disableLocaleStorageUsage() {
    useLocalStorage = false;

    if (localStorage.getItem(storageKey)) {
      localStorage.removeItem(storageKey);
    }
  }

  return {
    key: storageKey,
    target,
    setTarget,
    reset,
    enableLocaleStorageUsage,
    disableLocaleStorageUsage,
  };
}
